module.exports = __webpack_public_path__ + "static/img/2_1.c78109fc.jpg";